export function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}
//# sourceMappingURL=sleep.js.map